module.exports = __webpack_public_path__ + "plaque-stages.b77dcd76b1185faebfa8c8dfe91d8872.png";